import { ITranslationValues, KeyPath, tr as fpTr } from "@backpacker/dico/tr";
import translate from "@backpacker/dico/translate";
import { Locale } from "@linkfluence/models/locale";
import {
  getCategoryFacetName,
  getCountryLabel,
  getFacetName,
  getLanguageLabel,
  getMetricLabel,
  getPlatformLabel,
} from "./labels";
import resources from "./resources";

// eslint-disable-next-line @typescript-eslint/ban-types
type Path = KeyPath<typeof resources["en_GB"]> | (string & {});

export const tr = (
  locale: Locale = Locale.English,
  key: Path,
  values: ITranslationValues = {},
  field: string = "count"
) => {
  return fpTr(resources, locale, key, values, field);
};

export const Translate = translate(resources);

export {
  getCategoryFacetName,
  getCountryLabel,
  getFacetName,
  getLanguageLabel,
  getMetricLabel,
  getPlatformLabel,
};
